import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import useFilter from '@/modern/actions/useFilter'
import SuperPrecoStamp from '@/modern/components/Stamps/SuperPreco'
import CarDeliveryStamp from '@/modern/components/Stamps/CarDelivery'
import TrocaComTrocoStamp from '@/modern/components/Stamps/TrocaComTroco'
import VideoChamadaStamp from '@/modern/components/Stamps/VideoChamada'

import { AlignFlagsStamp } from './style'

const DefineOrderSeals = ({ stamps }) => {
  const { filter } = useFilter('superSealOff')
  const orderedStamps = useMemo(
    () => ({
      superPreco: !filter && stamps.superPreco,
      trocaComTroco: stamps.trocaComTroco,
      carDelivery: stamps.carDelivery,
      videoChamada: false,
    }),
    [filter, stamps]
  )

  const stampsObject = useMemo(
    () => ({
      superPreco: <SuperPrecoStamp />,
      carDelivery: <CarDeliveryStamp />,
      videoChamada: <VideoChamadaStamp />,
      trocaComTroco: <TrocaComTrocoStamp />,
    }),
    []
  )

  const componentsObject = useMemo(() => {
    const components = Object.keys(orderedStamps)
      .filter(key => orderedStamps[key])
      .map(key => ({
        key,
        component: stampsObject[key],
      }))
      .slice(0, 3)

    return components.length > 0 ? components : null
  }, [orderedStamps, stampsObject])

  return (
    componentsObject && (
      <AlignFlagsStamp>
        {componentsObject.map(({ key, component }) => (
          <React.Fragment key={key}>{component}</React.Fragment>
        ))}
      </AlignFlagsStamp>
    )
  )
}

DefineOrderSeals.propTypes = {
  stamps: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
  ).isRequired,
}

export default DefineOrderSeals
